var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"footer"},[_vm._v(" @ 2019 "),_c('span',{staticClass:"my_pointer",on:{"click":_vm.toHomePage}},[_vm._v("YYASHOW")]),_vm._v(" All rights reserved. ")])}
var staticRenderFns = []

export { render, staticRenderFns }